import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure74 = {
chart: {
backgroundColor: 'rgba(255, 255, 255, 0.0)',		       
type: 'column'
       },
       credits: {
	       enabled: false
       },
title: {
text: ''
},
xAxis: [{
categories: ['Afrique subsaharienne', 'Afrique du Nord et Asie de l’Ouest', 'Asie centrale et Asie du Sud', 'Asie de l’Est et Asie du Sud-Est', 'Amérique latine et Caraïbes', 'Australie et Nouvelle-Zélande', 'Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)', 'Europe et Amérique du Nord'],
}],
yAxis: [{ // Primary yAxis
min: 0,
max: 100,
tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
labels: {
formatter: function () {
return this.value + '';
}
},
title: {
text: 'Indice de couvert végétal montagneux',
//style: {
//  color: Highcharts.getOptions().colors[1]
//}
},
opposite: true
}, { // Secondary yAxis
title: {
useHTML: true,		       
text: 'Superficie en milliers de km<sup>2</sup>',
//style: {
//  color: Highcharts.getOptions().colors[0]
//}
},
min: 0,
max: 12000,
tickPositions: [0, 2000, 4000, 6000, 8000, 10000, 12000],
labels: {
formatter: function () {
return this.value + '';
}
},
}],
tooltip: {
shared: false
},
legend: {
	       enabled: false,
       }, 
plotOptions: {
column: {
stacking: 'normal', // Merge the columns as stacked

//grouping:true
}
},
series: [
       {
	       name: 'Plans d’eau intérieurs',
	       data: [19.4203, 4.78225, 7.378, 55.10762, 28.20407, 2.09765, 0.42793, 94.36367
],
	       color: '#5475a8',
	       yAxis: 1,
       },
       {
	       name: 'Neiges éternelles et glaciers',
	       data: [0.65564, 0.36208, 37.22691, 63.53969, 39.07545, 1.28708, 0, 869.88178
],
	       color: '#d6dce5',
	       yAxis: 1,
       },	 
       {
	       name: 'Terres stériles',
	       data: [246.41447, 793.20886, 752.60144, 725.28745, 348.91592, 9.08518, 0.03358, 591.15093
],
	       color: '#9a8f72',
	       yAxis: 1,
       },	 
       {
	       name: 'Zones à faible végétation',
	       data: [40.30878, 241.33588, 206.832, 200.41773, 441.24508, 8.03508, 1.27115, 977.1843
],
	       color: '#dcca8f',
	       yAxis: 1,
       },	 
{
name: 'Zones humides',
data: [11.79112, 0.44736, 0.34669, 10.47692, 7.56545, 0.44836, 0, 42.49971],
color: '#65b3d6',
yAxis: 1,
}, {
name: 'Zones couvertes d’arbustes',
data: [669.79951, 73.71164, 101.05448, 158.6399, 964.87208, 50.60491, 0.21938, 1399.76042],
color: '#82b99c',
yAxis: 1,
}, {
name: 'Zones boisées',
data: [1167.79511, 275.84859, 449.72662, 2843.50754, 1943.78188, 201.99975, 212.4414, 5684.08846],
color: '#548135',
yAxis: 1,
}, {
name: 'Prairies',
data: [405.48259, 89.52975, 675.69277, 2222.21242, 414.45977, 70.44836, 0.44985, 734.90792],
color: '#c4dda0',
yAxis: 1,
}, {
name: 'Terres en cultures',
data: [698.20622, 513.70311, 571.06439, 1198.90471, 372.54514, 28.41889, 19.10039, 464.44038],
color: '#fed966',
yAxis: 1,
}, {
name: 'Surfaces artificielles',
data: [4.52091, 7.63048, 5.52797, 13.34949, 14.97082, 0.53264, 0.04628, 19.77497],
color: '#c00000',
yAxis: 1,
},
{
name: 'Indice de couvert végétal montagneux', 
type: 'scatter',
data: [90.46, 47.65, 64.04, 85.88, 80.93, 94.36, 99.24, 76.54],
color: '#000000',
}]
}